// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__ar9XY","footer":"ModalFilter_footer__2hXis"};